<ihd-modal class="c-modal--xxs c-modal--primary" [createOverlay]="false">
    <div class="c-modal__header">
        <ihd-tabs [items]="tabItems"></ihd-tabs>
        <ihd-button-group class="ml-auto c-btn-group--gap-2">
            <div class="c-btn-group__vert-divider--fill c-btn-group__vert-divider"></div>
            <button ihdIconButton icon="close" class="x-modal__icon-btn c-icon-btn--xs" (click)="closeDialog()">
                <ihd-tooltip>{{ 'Common.Close' | translate }}</ihd-tooltip>
            </button>
        </ihd-button-group>
    </div>
    <div class="c-modal__body">
        <div class="c-modal__body-content c-modal__body--no-scroller" [formGroup]="billingForm" [ihdFormSubmitted]="isSubmitted">
            <div class="c-form-group">
                <div class="l-form-row">
                    <div class="l-col">
                        <label>{{ 'Profile.BasicInfo.FirstName' | translate }}</label>
                        <input type="text" formControlName="first_name" class="c-form-control"
                            placeholder="{{ 'Profile.BasicInfo.FirstName' | translate }}">
                        <ihd-form-messages [form]="billingForm" name="first_name" [submitted]="isSubmitted">
                            <ihd-form-message name="required">{{ 'Common.Error.Required' | translate }}</ihd-form-message>
                        </ihd-form-messages>
                    </div>
                    <div class="l-col">
                        <label>{{ 'Profile.BasicInfo.LastName' | translate }}</label>
                        <input type="text" formControlName="last_name" class="c-form-control"
                            placeholder="{{'Profile.BasicInfo.LastName'|translate}}">
                        <ihd-form-messages [form]="billingForm" name="last_name" [submitted]="isSubmitted">
                            <ihd-form-message name="required">{{ 'Common.Error.Required' | translate }}</ihd-form-message>
                        </ihd-form-messages>
                    </div>
                </div>
            </div>
            <div class="c-form-group">
                <div class="l-form-row">
                    <div class="l-col">
                        <label>{{ 'Profile.BasicInfo.Email' | translate }}</label>
                        <input type="email" formControlName="email" class="c-form-control"
                            placeholder="{{'Profile.BasicInfo.Email'|translate}}">
                        <ihd-form-messages [form]="billingForm" name="email" [submitted]="isSubmitted">
                            <ihd-form-message name="email">{{ 'Common.Error.InvalidEmail' | translate }}</ihd-form-message>
                            <ihd-form-message name="required">{{ 'Common.Error.Required' | translate }}</ihd-form-message>
                        </ihd-form-messages>
                    </div>
                </div>
            </div>
            <fieldset formGroupName="address">
                <div class="c-form-group">
                    <div class="l-form-row">
                        <div class="l-col-7">
                            <label>{{ 'Billing.Details.Address' | translate }}</label>
                            <input type="text" formControlName="line1" class="c-form-control"
                                placeholder="{{ 'Billing.Details.Address' | translate }}">
                            <ihd-form-messages [form]="billingForm" name="address" [submitted]="isSubmitted">
                                <ihd-form-message name="line1">{{ 'Common.Error.Required' | translate }}</ihd-form-message>
                            </ihd-form-messages>
                        </div>
                        <div class="l-col-5">
                            <label>{{ 'Billing.Details.City' | translate }}</label>
                            <input type="text" formControlName="city" class="c-form-control"
                                placeholder="{{ 'Billing.Details.City' | translate }}">
                            <ihd-form-messages [form]="billingForm" name="address" [submitted]="isSubmitted">
                                <ihd-form-message name="city">{{ 'Common.Error.Required' | translate }}</ihd-form-message>
                            </ihd-form-messages>
                        </div>
                    </div>
                </div>
                <div class="c-form-group c-form-group--divider pb-5">
                    <div class="l-form-row">
                        <div class="l-col-3">
                            <label>{{ 'Billing.Details.State' | translate }}</label>
                            <input type="text" formControlName="state" class="c-form-control"
                                placeholder="{{ 'Billing.Details.State' | translate }}">
                            <ihd-form-messages [form]="billingForm" name="address" [submitted]="isSubmitted">
                                <ihd-form-message name="state">{{ 'Common.Error.Required' | translate }}</ihd-form-message>
                            </ihd-form-messages>
                        </div>
                        <div class="l-col-4">
                            <label>{{ 'Billing.Details.PostalCode' | translate }}</label>
                            <input type="text" formControlName="postal_code" class="c-form-control"
                                placeholder="{{ 'Billing.Details.PostalCode' | translate }}">
                            <ihd-form-messages [form]="billingForm" name="address" [submitted]="isSubmitted">
                                <ihd-form-message name="postalCode">{{ 'Common.Error.Required' | translate }}</ihd-form-message>
                            </ihd-form-messages>
                        </div>
                        <div class="l-col-5">
                            <label>{{ 'Billing.Details.Country' | translate }}</label>
                            <input type="text" formControlName="country" class="c-form-control"
                                placeholder="{{ 'Billing.Details.Country' | translate }}">
                            <ihd-form-messages [form]="billingForm" name="address" [submitted]="isSubmitted">
                                <ihd-form-message name="country">{{ 'Common.Error.Required' | translate }}</ihd-form-message>
                            </ihd-form-messages>
                        </div>
                    </div>
                </div>
            </fieldset>
            <div class="c-modal__body-footer px-0 mt-2">
                <div class="d-flex justify-content-end">
                    <button ihdButton type="button" (click)="submit()"
                        class="c-btn--primary c-btn--lg c-btn--wlg"
                        [disabled]="(billingForm.invalid && isSubmitted) || isLoading || !hasChanges">
                        {{'Billing.Subscription.Update.CTA' | translate}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</ihd-modal>
